import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Logo } from '../brand/Logo';

export const MessageScreen = (p: PropsWithChildren<unknown>) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          textAlign: 'center',
        }}
      >
        <Logo style={{ maxHeight: 45 }} />
        {p.children}
      </Box>
    </Box>
  );
};
